import { render } from "./SavedCollectionsSearchField.vue?vue&type=template&id=59a40906&scoped=true"
import script from "./SavedCollectionsSearchField.vue?vue&type=script&lang=js"
export * from "./SavedCollectionsSearchField.vue?vue&type=script&lang=js"

import "./SavedCollectionsSearchField.vue?vue&type=style&index=0&id=59a40906&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59a40906"]])

export default __exports__